module.exports = __webpack_public_path__ + "img/placeholder.588d9346.jpg";